import React, { useState } from 'react';
import BundlerProducts from './BundlerProducts';

const Bundler = ({
  CategoryData,
  detailsModal,
  setDetailsModal,
  finalArray,
  setFinalArray,
  productList,
  setProductList,
}) => {
  const [cartItems, setCartItems] = useState([]);

  const [selectArray, setSelectArray] = useState([]);

  return CategoryData.map((productCategory, index) => {
    return (
      <div
        className="xrs-bundler-category"
        id={productCategory.categoryName}
        key={index}
      >
        <span>
          <h4 className="">{productCategory.categoryName}</h4>
        </span>
        <BundlerProducts
          categoryData={productCategory}
          cartItems={cartItems}
          setCartItems={setCartItems}
          finalArray={finalArray}
          setFinalArray={setFinalArray}
          setSelectArray={setSelectArray}
          selectArray={selectArray}
          detailsModal={detailsModal}
          setDetailsModal={setDetailsModal}
          productList={productList}
          setProductList={setProductList}
        />
      </div>
    );
  });
};

export default Bundler;
